import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFillOpaque = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 4,
		y: 4,
		width: 16,
		height: 16,
		rx: 2,
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFillOpaque;
